/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FuelUpVaultActionRequest
 */
export interface FuelUpVaultActionRequest {
    /**
     * Vault action to perform
     * @type {string}
     * @memberof FuelUpVaultActionRequest
     */
    action: FuelUpVaultActionRequestActionEnum;
    /**
     * Amount of fuel (required for deposit/withdraw)
     * @type {number}
     * @memberof FuelUpVaultActionRequest
     */
    amount?: number;
    /**
     * Target level for upgrade (1-10)
     * @type {number}
     * @memberof FuelUpVaultActionRequest
     */
    targetLevel?: number;
    /**
     * Position on board if landing on vault space
     * @type {number}
     * @memberof FuelUpVaultActionRequest
     */
    spacePosition?: number;
}


/**
 * @export
 */
export const FuelUpVaultActionRequestActionEnum = {
    deposit: 'deposit',
    withdraw: 'withdraw',
    evolve: 'evolve',
    upgrade: 'upgrade'
} as const;
export type FuelUpVaultActionRequestActionEnum = typeof FuelUpVaultActionRequestActionEnum[keyof typeof FuelUpVaultActionRequestActionEnum];


/**
 * Check if a given object implements the FuelUpVaultActionRequest interface.
 */
export function instanceOfFuelUpVaultActionRequest(value: object): value is FuelUpVaultActionRequest {
    if (!('action' in value) || value['action'] === undefined) return false;
    return true;
}

export function FuelUpVaultActionRequestFromJSON(json: any): FuelUpVaultActionRequest {
    return FuelUpVaultActionRequestFromJSONTyped(json, false);
}

export function FuelUpVaultActionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FuelUpVaultActionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'action': json['action'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'targetLevel': json['targetLevel'] == null ? undefined : json['targetLevel'],
        'spacePosition': json['spacePosition'] == null ? undefined : json['spacePosition'],
    };
}

export function FuelUpVaultActionRequestToJSON(json: any): FuelUpVaultActionRequest {
    return FuelUpVaultActionRequestToJSONTyped(json, false);
}

export function FuelUpVaultActionRequestToJSONTyped(value?: FuelUpVaultActionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'action': value['action'],
        'amount': value['amount'],
        'targetLevel': value['targetLevel'],
        'spacePosition': value['spacePosition'],
    };
}

